import { Controller } from 'stimulus'
import { setupTimers } from '~/common/behaviors/timer'
import './quiz_component.scss'

export default class extends Controller {
  static targets = ['submitButton']
  connect() {
    setupTimers()
  }

  updateSubmitButtonDisabledState() {
    this.submitButtonTarget.disabled =
      !this.element.querySelector('input:checked')
  }
}
